import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import AuctionCard from "../components/AuctionCard";

export default function Watchlist() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { if (!loading && !user) nav("/signin?next=/watchlist"); }, [user, loading, nav]);
  useEffect(() => { if (user) api.get("/watchlist").then(r => setItems(r.data)); }, [user]);
  if (!user) return null;
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-amber-600">Your Watchlist</div>
      <h1 className="text-3xl md:text-4xl font-extrabold mb-8">Saved auctions</h1>
      {items.length === 0 ? (
        <div className="text-center text-slate-500 py-16">Your watchlist is empty.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map(l => <AuctionCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
